<template >
<div class="filter">
  <span class="material-symbols-outlined close" @click="handleClose">close</span>
  <div class="filterDivider" @change="handleSubmit">
    <label class="labelPreview">{{ $t('preview.PreviewDevice') }}</label>
    <select v-model="device">
      <option value="Phone">6,1" Smartphone (2556 x 1179)</option>
      <option value="Tablet" >14,6 " Tablet (2960 x 1848)</option>
      <option value="Desktop">24" Standard Monitor (1920 x 1080) </option>
    </select>
  </div>   
  <div class="filterDivider">
  <label class="labelPreview">Zoom</label>
  <div class="range-container">
    <input @change="handleZoom" v-model="zoomLevel" type="range" min="1" max="5" value="1" class="slider" id="myRange"> {{ zoomLevel }}x  
  </div>
  <!-- <div class="textZoom"><span>Punktgenauer</span><span class="material-icons">zoom_in</span><span>&</span>
  <span class="material-icons">zoom_out</span><span>auch per Doppelclick (linke Maustaste) möglich</span> 
  </div> -->
</div>
</div>
</template>
    
<script>
export default {
  props: ['reset'],
  data() {
      return{
      device: 'Phone',
      zoomLevel: 1,
      page: 'page1'
  }},
  watch: {
    reset: function(newVal) { // watch it
      if (newVal === true){
        this.zoomLevel = 1;
        this.$emit("reseted")
      }
   }},
  methods: {
    handleSubmit(){
    switch(this.device){
      case 'Phone':
        this.$emit("filtered", this.device)
        this.zoomLevel= 1;
        break;
      case 'Tablet':
        this.$emit("filtered", this.device)
        this.zoomLevel= 1;
        break;
      case 'Desktop':
        this.$emit("filtered", this.device)
        this.zoomLevel= 1;
        break;
    }},
    handleZoom(){
      this.$emit("zoom", this.zoomLevel)
    },
    handleClose(){
      this.$emit("close")
    },
    handlePage(){
      this.$emit("previewPage", this.page)
      console.log(this.page)
    }
  }}
</script>

<style scoped>
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');

.filter{
align-items: center;
justify-content: center;
font-family: "Montserrat", sans-serif;
font-optical-sizing: auto;
font-style: normal;
display: flex;
background: white;
border-radius: 15px;
padding: 5px;
box-shadow: 0 0 20px #3a3838;
position: relative;
}

.close{
  position: absolute;
  top: 5px;
  right: 10px;
  cursor: pointer;
}

.range-container{
  margin:auto;
  margin-top: 5px;
}

.filterDivider {
width: 40%;
margin: auto;
text-align: left;
}


p{
margin: auto;
margin-left: 60px;
font-family: "Montserrat", sans-serif;
font-optical-sizing: auto;
font-style: normal;
}

select{
cursor: pointer;
}

.material-icons {
font-size: 40px;
}

.labelPreview {
color: #aaa;
display: inline-block;
margin: 15px 0 15px;
font-size: 0.6em;
text-transform: uppercase;
letter-spacing: 1px;
font-weight: bold;
}

input, select {
display: block;
margin-left: 0;
width: 100%;
box-sizing: border-box;
border: none;
/* color: #555; */
} 


.textZoom {
font-size: 12px;
}

.material-icons{
  font-size: 25px;
  display: inline-flex;
  vertical-align: middle;
}


.previewHTML {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

</style>